import React from 'react';

import Tabs, { TabsProps } from 'antd/es/tabs';

import { useMobileView } from '@common/react/hooks/useMobileView';

interface AppointmentETFiltersTabsProps extends Omit<TabsProps, 'items'> {
	items: any;
}

const AppointmentETFiltersTabs: React.FC<AppointmentETFiltersTabsProps> = (props) => {
	const isMobile = useMobileView(768);
	const enableItems = props.items
		.filter((item) => item.visible === undefined || item.visible);
	const [tab, selectTab] = React.useState<string>(enableItems[0].key);
	const solveItems = props.items
		.filter((item) => item.visible === undefined || item.visible)
		.map((item) => {
			const onClick = () => {
				if (tab !== item.key && isMobile) {
					return;
				}
				item.onBadgeClick();
			};

			return {
				...item,
				label: <>
					{item.label}
					&nbsp;
					{item.count > 0 && item.count !== undefined
						&& <div
							onClick={onClick}
							className="badge dashboard-container-user-block__badge"
						>
							<span>
								{' '}
								{item.count}
							</span>
							<i className="fa fa-times" />
						</div>}
				</>,
			};
		});
	return <Tabs
		{...props}
		items={solveItems}
		activeKey={tab}
		onChange={selectTab}
	/>;
};

export default AppointmentETFiltersTabs;
